export default __webpack_public_path__ + "static/media/hessahStorePic.d0df44d5.png";